// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"5933152a0f30b40701df","3419":"018c9b5f50aa54656876"}[chunkId] + ".css";
};